// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"353":"contact","594":"about","608":"Impressum","652":"service","810":"NotFound","838":"Disclaimer","993":"home-one"}[chunkId] || chunkId) + "-legacy." + {"353":"8a8390cb","590":"93e07b66","594":"41dbf2ca","608":"9d7ca692","652":"74f9333b","810":"dad54375","838":"fb8e107e","993":"2f4607b7"}[chunkId] + ".js";
};